var map = {
	"./Base": 733,
	"./Base/": 733,
	"./Base/index": 733,
	"./Base/index.js": 733,
	"./Base/style": 175,
	"./Base/style.js": 175,
	"./Clutch": 424,
	"./Clutch/": 424,
	"./Clutch/index": 424,
	"./Clutch/index.js": 424,
	"./Clutch/renderComponent": 1666,
	"./Clutch/renderComponent.js": 1666,
	"./Clutch/style": 1305,
	"./Clutch/style.js": 1305,
	"./NewUi": 1025,
	"./NewUi/": 1025,
	"./NewUi/index": 1025,
	"./NewUi/index.js": 1025,
	"./NewUi/style": 1306,
	"./NewUi/style.js": 1306,
	"./OldUi": 1026,
	"./OldUi/": 1026,
	"./OldUi/index": 1026,
	"./OldUi/index.js": 1026,
	"./OldUi/renderComponent": 1667,
	"./OldUi/renderComponent.js": 1667,
	"./OldUi/style": 1307,
	"./OldUi/style.js": 1307,
	"./SpireonNew": 1027,
	"./SpireonNew/": 1027,
	"./SpireonNew/index": 1027,
	"./SpireonNew/index.js": 1027,
	"./SpireonNew/renderComponent": 1668,
	"./SpireonNew/renderComponent.js": 1668,
	"./SpireonNew/style": 1308,
	"./SpireonNew/style.js": 1308,
	"./SpireonOld": 1028,
	"./SpireonOld/": 1028,
	"./SpireonOld/index": 1028,
	"./SpireonOld/index.js": 1028,
	"./SpireonOld/renderComponent": 1669,
	"./SpireonOld/renderComponent.js": 1669,
	"./SpireonOld/style": 1309,
	"./SpireonOld/style.js": 1309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;